import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _get from "lodash/get";
var _excluded = ["justifyContent", "alignItems", "flexWrap", "children", "isFullHeight"];
import React, { useContext } from 'react';
import { Flex } from '@rebass/grid';
import { ThemeContext } from 'styled-components';
import layoutTheme from '../../styles/layoutTheme';

var Row = function Row(_ref) {
  var justifyContent = _ref.justifyContent,
      alignItems = _ref.alignItems,
      flexWrap = _ref.flexWrap,
      children = _ref.children,
      isFullHeight = _ref.isFullHeight,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var theme = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(Flex, Object.assign({
    mx: -_get(theme, 'layout.grid.gutter', layoutTheme.layout.grid.gutter),
    flexWrap: flexWrap,
    flex: "1 1 auto",
    justifyContent: justifyContent,
    alignItems: alignItems,
    height: isFullHeight ? '100%' : 'auto'
  }, props), children);
};

Row.defaultProps = {
  justifyContent: undefined,
  alignItems: undefined,
  flexWrap: 'wrap',
  children: undefined,
  isFullHeight: false
};
export default Row;